import { render } from "./TitleComponentS.vue?vue&type=template&id=22d0d7e9&scoped=true"
import script from "./TitleComponentS.vue?vue&type=script&lang=js"
export * from "./TitleComponentS.vue?vue&type=script&lang=js"

import "./TitleComponentS.vue?vue&type=style&index=0&id=22d0d7e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d0d7e9"]])

export default __exports__